import React from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useLeaveType } from '../../hooks/CompanyConfiguration/useLeaveType'

import LeaveTypeForm from '../Masters/LeaveTypeForm'

function EditLeaveType() {
  const params = useParams()
  const { leaveType, getLeaveType } = useLeaveType()

  React.useEffect(() => {
    getLeaveType({ leaveTypeId: params.leaveTypeId })
  }, [params.leaveTypeId])

  return <>{leaveType ? <LeaveTypeForm leaveType={leaveType} /> : <Loader />}</>
}

export default EditLeaveType
